"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.headingMarkupOptionDefaultInSectionHeading = exports.headingMarkupOptionDefault = exports.headingMarkupOptionMap = void 0;
exports.headingMarkupOptionMap = {
    'Option 1': 'eyebrow as hN, heading as p',
    'Option 2': 'heading as hN, eyebrow as hN+1',
};
exports.headingMarkupOptionDefault = exports.headingMarkupOptionMap['Option 1'];
exports.headingMarkupOptionDefaultInSectionHeading = exports.headingMarkupOptionMap['Option 2'];
//# sourceMappingURL=headings.js.map